// extracted by mini-css-extract-plugin
export default {"centered":"ForgotPasswordPage_centered__Cma0m","container":"ForgotPasswordPage_container__Z-X75"};